var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary"}},[_c('a',{staticClass:"btn btn-primary btn-block",staticStyle:{"color":"white","text-decoration":"none"},attrs:{"href":_vm.model.sourceImage,"download":""}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Download")])])
}
var staticRenderFns = []

export { render, staticRenderFns }